import React from "react";
import "./btnStandardLanding.scss";

const BtnStandardLanding = ({
  mode,
  txt,
  svg,
  svgDisabled,
  disabled,
  mainColor,
  icon,
  size,
  iconPosition,
  onClick,
  styles,
}) => {
  return (
    <button
      style={styles}
      className={
        !disabled
          ? `btn-standard-icon-text ${mainColor} ${size} ${mode}`
          : `btn-standard-icon-text ${mainColor} ${size} disabled`
      }
      onClick={onClick}
    >
      {icon && iconPosition === "left" && disabled ? svgDisabled : svg}
      <span className="txt">{txt}</span>
      {icon && iconPosition === "right" && (disabled ? svgDisabled : svg)}
    </button>
  );
};

export default BtnStandardLanding;
